import { Button, Checkbox, Container, FormControl, FormErrorMessage, FormHelperText, FormLabel, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Textarea } from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import { FC, useEffect, useState } from "react";
import LogosNotification from "utils/notification-utils";
import ProgramService from "../../../../services/programs/program-service";

interface AddLessonGroupDialogProps {
    program: any,
    lessonGroupId:string,
    lesson: any,
    onClose: any,
    onRefreshData: any
};

const formInitialValue = {
    name: '',
    description: '',
    author: '',
    resourceType: 40,
    posterImage: null,
    resourceFile: null
};

const AddLessonResourceDialog: FC<AddLessonGroupDialogProps> = ({ program, lessonGroupId, lesson, onClose, onRefreshData }) => {
    const [formValue, setFormValue] = useState<any>(formInitialValue);
    const [isSubmiting, setIsSubmiting] = useState<boolean>(false);

    useEffect(() => {
    }, []);

    const handleFormSubmit = (values: any) => {
        setIsSubmiting(true);
        ProgramService.AddLessonResource(program.id, lessonGroupId, lesson.id, values.name, values.description, values.author, values.resourceType, values.posterImage, values.resourceFile).then((res: any) => {
            LogosNotification.Success("Resource berhasil ditambahkan.");
            window.location.reload();
        }).finally(() => {
            setIsSubmiting(false);
        })
    };

    const formValidation = (values: any) => {
        if (values.posterImage == null)
            return { posterImage: 'Silahkan Gambar Poster resource.' };
        if (values.resourceFile == null)
            return { resourceFile: 'Silahkan File Resource.' };
    };

    return (
        <Modal isOpen={true} onClose={onClose} >
            <ModalOverlay />
            <ModalContent>
                <Formik initialValues={formValue} onSubmit={handleFormSubmit} validate={formValidation}>
                    {
                        ({ handleSubmit, errors, touched, setFieldValue }) => (
                            <Form onSubmit={handleSubmit} noValidate={true}>
                                <ModalHeader textAlign={"center"}>Tambah Resource Baru</ModalHeader>
                                <ModalBody pt={5}>

                                    <FormControl isRequired isInvalid={!!(errors.name && touched.name)}>
                                        <FormLabel htmlFor='name'>Nama</FormLabel>
                                        <Field
                                            as={Input}
                                            id='name'
                                            placeholder='Nama Group Lesson'
                                            name={'name'}
                                            validate={(value: any) => {
                                                let error;
                                                if (value.length <= 0)
                                                    error = "Nama wajib diisi.";
                                                return error;
                                            }}
                                        />
                                        <FormErrorMessage>{errors.name}</FormErrorMessage>
                                    </FormControl>

                                    <FormControl mt={4} isRequired isInvalid={!!(errors.description && touched.description)}>
                                        <FormLabel htmlFor='name'>Deskripsi</FormLabel>
                                        <Field
                                            as={Textarea}
                                            id='description'
                                            placeholder='Dekripsi Resource'
                                            name={'description'}
                                            noOfLines={3}
                                            validate={(value: any) => {
                                                let error;
                                                if (value.length <= 0)
                                                    error = "Deskripsi Resource wajib diisi.";
                                                return error;
                                            }}
                                        />
                                        <FormErrorMessage>{errors.description}</FormErrorMessage>
                                    </FormControl>

                                    <FormControl mt={4} isRequired isInvalid={!!(errors.author && touched.author)}>
                                        <FormLabel htmlFor='name'>Pencipta</FormLabel>
                                        <Field
                                            as={Input}
                                            id='author'
                                            placeholder='Nama Pencipta'
                                            name={'author'}
                                            validate={(value: any) => {
                                                let error;
                                                if (value.length <= 0)
                                                    error = "Nama Pencipta wajib diisi.";
                                                return error;
                                            }}
                                        />
                                        <FormErrorMessage>{errors.author}</FormErrorMessage>
                                    </FormControl>

                                    <FormControl mt={4} isRequired isInvalid={!!(errors.resourceType && touched.resourceType)}>
                                        <FormLabel htmlFor='resourceType'>Type Resource</FormLabel>
                                        <Field as={Select} id='resourceType' placeholder='Type' name={'resourceType'}>
                                            <option value={0}>Video</option>
                                            <option value={20}>PDF</option>
                                            <option value={30}>Excel</option>
                                            <option value={40}>Others</option>
                                        </Field>
                                    </FormControl>

                                    <FormControl mt={4} isRequired isInvalid={!!(errors.posterImage && touched.posterImage)}>
                                        <FormLabel htmlFor='screenshot'>Gambar Poster</FormLabel>
                                        <input
                                            type={'file'}
                                            id='posterImage'
                                            name={'posterImage'}
                                            accept="image/*"
                                            onChange={(event: any) => {
                                                setFieldValue("posterImage", event.currentTarget.files[0]);
                                            }}
                                        />
                                        <FormHelperText>Ukuran: 500 x 500 px</FormHelperText>
                                        <FormErrorMessage>{errors.posterImage}</FormErrorMessage>
                                    </FormControl>

                                    <FormControl mt={4} isRequired isInvalid={!!(errors.resourceFile && touched.resourceFile)}>
                                        <FormLabel htmlFor='resourceFile'>File Resource</FormLabel>
                                        <input
                                            type={'file'}
                                            id='resourceFile'
                                            name={'resourceFile'}
                                            accept="*/*"
                                            onChange={(event: any) => {
                                                setFieldValue("resourceFile", event.currentTarget.files[0]);
                                            }}
                                        />
                                        <FormErrorMessage>{errors.resourceFile}</FormErrorMessage>
                                    </FormControl>

                                </ModalBody>
                                <ModalFooter>
                                    <Button variant={'outline'} mr={3} onClick={onClose}>
                                        Close
                                    </Button>
                                    <Button type={'submit'} isLoading={isSubmiting}>Tambah Sekarang</Button>
                                </ModalFooter>
                            </Form>
                        )
                    }
                </Formik>
            </ModalContent>
        </Modal>
    );
};

export default AddLessonResourceDialog;
